angular
    .module("accordionUploadDocumentsInstantPostVend.components", [])
    .component("accordionUploadDocumentsInstantPostVend", {
        templateUrl: "ng/components/accordionUploadDocumentsInstantPostVend/accordionUploadDocumentsInstantPostVend.view.html",
        bindings: {
            userDaCensire: "=",
            enabledSave: "&",
            isIntegration: "<",
            goBackModal: "&",
            isDigital: '<',
            snapshot: '<',
            portalRunned: '<',
            postVendita: '=',
            showAllInfo: '<',
            modelFirma: '<',
            firmaChanged: '<',
            hideChoiceOfRole: '<',
            hideCf: '<',
            editModeMinimal: '<'
        },
        controllerAs: "uploadDocumentsInstantPostVendCtrl",
        controller: function accordionUploadDocuments(
            $configService,
            $rootScope,
            $timeout,
            $typeDomainService,
            Documento,
            $modalService,
            $scope,
            validationService,
            Pf,
            $download,
            $userService,
            HttpService,
            EnteRilascio,
            $portalService,
            $istatService
        ) {
            var self = this;
            var getStati = function () {
                $istatService.getNazioni()
                    .then(function (response) {
                        self.listaNomiStatiNascita = response.domainList;

                        self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                            function (elem) {
                                return elem.name && elem.name.toUpperCase() != "ITALIA";
                            }
                        );
                        self.listaNomiStatiResidenza = self.listaNomiStatiNascita.filter(
                            function (element) {
                                return !element.deleted
                            }
                        )
                        self.listStatiRilascio = self.listaNomiStatiNascita.map(function (element) {
                            return element.name;
                        })
                    })
            };

            jQuery(window).resize(function () {
                // This will execute whenever the window is resized

                var widthDisplay = jQuery(window).width();

                if (widthDisplay > 900) {
                    self.fullScreenMode = true;
                } else {
                    self.fullScreenMode = false;
                }
            });

            self.$onInit = (function () {
                var widthDisplay = jQuery(window).width();

                if (widthDisplay > 900) {
                    self.fullScreenMode = true;
                } else {
                    self.fullScreenMode = false;
                }
                self.testDati = {
                    value: true,
                    error: ""
                }
                self.cfAziendaleIsRequired = false;
                self.enteRilascioModel = "";
                self.disabledForUploadingInProgress = false;
                self.disabeldUploadFront = false;
                self.disabeldUploadBack = false;
                self.disabeldUploadCfFront = false;
                self.disabeldUploadCfBack = false;
                self.disabledFirmatarioTitolare = false;
                self.ilTransaction = 0;
                self.dealerUser = {};
                self.showLoader = false;
                self.base64 = null;
                self.link = "";
                self.progress = 0;
                self.frontBase64 = "";
                self.backBase64 = "";
                self.disabledInputCf = false;
                self.disabledInputDoc = false;
                self.mapComuni = $rootScope.comuniMap;
                self.comuniNsilSoppressi = $rootScope.mapComuniSoppressi;
                self.currentCodeTypeNameIndex = 0;
                self.listaProvince = [];
                self.listaProvinceRilascio = [];
                self.listaNomeComuniRilascio = [];
                self.listaNomeComuniNascita = [];
                self.listaNomiStatiNascita = [];
                self.listaNomiStatiResidenza = [];
                self.listaNomeComuniResidenza = [];
                self.listaCap = [];
                self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
                self.today = moment().format("DD/MM/YYYY");
                self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
                self.userDaCensire = self.userDaCensire | {};
                self.documentUpload = [];
                self.enabledModifyDocumentDate = false;
                self.currentSlide = 0;
                self.userDaCensire = {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                };
                Object.assign(self.userDaCensire, {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                });

                self.dropdown = {
                    ruolo: [],
                    stati: [],
                    comune: [],
                    statiEsteri: [],
                    entiRilascio: [],
                    tipiDocumento: [],
                    tipoGarante: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            "01-01",
                            "06-01",
                            "25-04",
                            "01-05",
                            "02-06",
                            "15-08",
                            "01-11",
                            "08-12",
                            "25-12",
                            "26-12"
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                };

                //albaInit();
                getStati();


                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);
                self.listaProvince.push("EE");
                self.listaProvinceRilascio = self.listaProvince
                // .filter(function (elem) {
                //     return elem != "EE"
                // });

                self.creaComuniRilascio = function (provincia, fromView) {
                    self.listaNomeComuniRilascio = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });

                    if (fromView) {
                        self.userDaCensire.documento.luogoEsteso = "";
                    }

                };

                self.creaComuniNascita = function (provincia) {
                    self.listaNomeComuniNascita = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });
                    self.userDaCensire.datiNascita.luogoEsteso = "";
                    self.verifyDate();
                };

                self.creaComuniResidenza = function (provincia, check) {
                    if (!check) {
                        self.userDaCensire.residenza.cap = "";
                        self.userDaCensire.residenza.indirizzo = "";
                        self.userDaCensire.residenza.numeroCivico = "";
                        self.userDaCensire.residenza.comune = "";
                        self.userDaCensire.residenza.luogoEsteso = "";
                        self.userDaCensire.residenza.stato = "";
                    }

                    if (provincia == "EE") {
                        self.isForeign = true;
                        return;
                    } else {
                        self.isForeign = false;
                    }
                    self.listaNomeComuniResidenza = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });


                };

                self.creaCap = function (comune, chiamataDalRest) {

                    if (!chiamataDalRest) {
                        self.userDaCensire.residenza.cap = "";
                    }

                    if (comune.cap && comune.cap.length > 0) {
                        self.listaCap = comune.cap;

                    } else {
                        if (self.listaNomeComuniResidenza.length > 0 && comune.nome) {
                            var tempComune = self.listaNomeComuniResidenza
                                .find(function (element) {
                                    return element.nome.toUpperCase() == comune.nome.toUpperCase();
                                });

                            self.listaCap = tempComune && tempComune.cap;
                        }



                    }

                };
                //getRuoli();
                $typeDomainService
                    .getRoles()
                    .then(function (response) {
                        self.dropdown.ruolo = response;
                    })
                    .catch(function (err) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        });
                    });
                $typeDomainService
                    .getDomainSet("GARANTE", "ROLE")
                    .then(function (response) {
                        self.dropdown.tipoGarante = response.domainList && response.domainList
                            .map(function (element) {
                                return element.value
                            });
                    });
                $timeout(function () {
                    if ($portalService.isAra()) {
                        self.unlockDocumentFields = true;
                    } else {
                        self.unlockDocumentFields = false;
                    }
                    self.userDaCensire = Pf.build(self.userDaCensire);
                    self.enteRilascioModel = self.userDaCensire.documento.enteRilascio;
                    if (self.userDaCensire.documento.imgDocumentoCfFront) {
                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfFront,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfBack,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoFront,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoBack,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);
                        self.userDaCensire.isOk = false;

                        self.indexDocument = 0;
                        self.disabeldUploadCfFront = true;
                        self.disabeldUploadCfBack = true;
                        self.unlockDocumentFields = true;
                    }
                    if (!self.userDaCensire.documento.imgDocumentoFront && !self.userDaCensire.documento.imgDocumentoBack && $portalService.isAru()) {

                        self.userDaCensire.documento.tipo = "";

                    } else {
                        self.disabeldUploadFront = true;
                        self.disabeldUploadBack = true;
                    }
                    if (!self.userDaCensire.documento.idImgDocumentoFrontOther && !self.userDaCensire.documento.idImgDocumentoBackOther) {
                        self.userDaCensire.ulterioreDocumento.tipo = ""
                    }
                    if (self.userDaCensire.documento.tipo) {
                        self.enabledModifyDocumentDate = true;
                        self.regExpDocumento = self.userDaCensire.documento.tipo;
                    }
                    self.disabledUploadDocument();
                    //initCarousel();
                    dealerUser();

                    self.listaNomeRilascio = Documento.getEntiRilascio(
                        self.userDaCensire.documento.tipo
                    );
                    if (self.userDaCensire.residenza.provincia == "EE") {
                        self.isForeign = true;
                        return;
                    } else {
                        self.isForeign = false;
                    }
                    if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                        self.userDaCensire.residenza.luogoEsteso = "";

                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                        self.userDaCensire.datiNascita.luogoEsteso = "";

                    }
                    if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                        self.userDaCensire.documento.luogoEsteso = "";
                    }
                    if (self.userDaCensire.residenza.provincia) {
                        self.userDaCensire.residenza.luogoEsteso = {
                            nome: self.userDaCensire.residenza.comune

                        }
                        self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "" && self.userDaCensire.datiNascita.provincia) {
                        self.creaComuniNascita(self.userDaCensire.datiNascita.provincia);
                    }
                    if (self.userDaCensire.documento.provincia) {
                        self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                    }
                    if (self.isDigital) {
                        self.disabledFirmatarioIsCustomer = false;
                    }
                    if (self.userDaCensire.residenza.luogoEsteso.nome) {
                        self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                    }
                    if (self.modelFirma.firmaDigitale && !self.modelFirma.firmaDigitaleEsterna
                    ) {
                        self.enablePhone = true;
                    } else {
                        self.enablePhone = false;
                    }
                }, 1);

                self.typePerson = $configService.getUser().type
                if (self.typePerson === 'ASSOCIATE_PERSON' || self.typePerson === 'SIGNER') {
                    self.disabeldPep = true;
                    self.disabledFirmatarioTitolare = true;
                    self.userDaCensire.titolare = {
                        pep: {
                            selected: "N"
                        }
                    }

                } else {
                    self.disabledFirmatarioIsCustomer = false;
                }

                self.linkPep = '/uni/download/service-infos/' + encodeURIComponent('GLOSSARIO') + '/';

                //RN:12378303
                self.userDaCensire.firmatario.spid = 'N';    


            })(
                (self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                })
            );

            self.downloadInfoPep = () => {

                $download.getGenericDownload(self.linkPep)
                    .then(function (response) {
                        console.log(response);
                    })
            }


            self.check = function (el) {
                el.selected = !el.selected;
                if (!self.userDaCensire.firmatario.selected) {
                    self.userDaCensire.firmatario.ruolo = "";
                    self.userDaCensire.email = "";
                } else if (!self.userDaCensire.titolare.selected) {
                    self.userDaCensire.titolare.pep = "N";
                }



            };


            self.enabledTrashRemovePdf = function () {
                return self.documentUpload.some(function (element) {
                    return element.selected === true;
                });
            };

            self.leastDocumentUpload = function () {
                var ritorno = false;

                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgDocument" && element.name;
                });
                return ritorno;
            };

            self.leastDocumentCfUpload = function () {
                var ritorno = false;
                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgCf";
                });
                return ritorno;
            };

            self.enteRilascioSelezionato = function (ente) {
                if (self.userDaCensire.documento.tipo === "PAT") {
                    if (ente === "MINISTERO") {
                        self.regExpDocumento = "UCO";
                    } else if (ente === "DIPARTIM. TRASPORTI TERRESTI") {
                        self.regExpDocumento = "PAM";
                    } else if (ente === "PREFETTURA") {
                        self.regExpDocumento = "PAT";
                    }
                }
                console.log(ente);
                self.userDaCensire.documento.enteRilascio = {
                    name: ente
                };
            };

            self.listaEntiRilascio = function (preserveData) {
                if (preserveData) {
                    return;
                }
                /*                 self.userDaCensire.documento.imgDocumentoFront = "";
                                self.userDaCensire.documento.imgDocumentoBack = ""; */

                self.enabledModifyDocumentDate = true;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != "imgDocument";
                });
                self.disabledUploadDocument();
            };

            self.savePfData = function (pf) {
                console.log(pf);
                pf.isOk = true;
                self.modalShow = false;
                if (pf.documento.provincia != 'EE') {
                    pf.documento.luogo = pf.documento.luogoEsteso.nome;
                }
                pf.datiNascita.comune = pf.datiNascita.luogoEsteso.nome;
                pf.residenza.comune = pf.residenza.luogoEsteso.nome;
                pf.documento.enteRilascio = EnteRilascio.build(self.enteRilascioModel);
                pf = Pf.build(pf);
                self.enabledSave({
                    Pf: pf
                });
            };
            self.undoDocumentChanges = function (pf) {
                if (self.isIntegration === true || self.validateForm()) {
                    pf.isOk = true;
                    $modalService.closeModal("censusPerson");
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                } else {
                    pf.isOk = false;
                    $modalService.closeModal("censusPerson");
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                    self.enabledSave({
                        Pf: pf,
                        doNotNext: true
                    });
                }
                self.goBackModal && self.goBackModal();

            };

            self.getEndDate = function (dataRilascio) {
                if (dataRilascio) {
                    var tipoDocumento = self.userDaCensire.documento.tipo;
                    var dataNascita = self.userDaCensire.datiNascita.data;
                    var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                    var startYear = moment(dataRilascio).format("YYYY");
                    var startDay = moment(dataRilascio).format("DD");
                    var startMonth = moment(dataRilascio).format("MM");

                    var endDate = moment(dataRilascio)
                        .add(10, "years")
                        .format("DD/MM/YYYY");

                    if (
                        (tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                            tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                            tipoDocumento === propMap["DOC_TYPE_PAT"] ||
                            tipoDocumento === propMap['DOC_TYPE_PAM'] ||
                            tipoDocumento === propMap['DOC_TYPE_UCO']) &&
                        !!dataNascita
                    ) {
                        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                        var birthYear = moment(dataNascita).format("YYYY");
                        var birthDay = moment(dataNascita).format("DD");
                        var birthMonth = moment(dataNascita).format("MM");

                        if (birthMonth == '02' && birthDay == '29') {
                            birthMonth = '03';
                            birthDay = '01';
                        }

                        var futureBirthDay = moment(
                            birthDay + "/" + birthMonth + "/" + startYear,
                            "DD/MM/YYYY"
                        )
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                        //console.log("Compleanno Futuro: " + futureBirthDay);

                        var daysDiff = moment
                            .duration(
                                moment(endDate, "DD/MM/YYYY").diff(
                                    moment(futureBirthDay, "DD/MM/YYYY")
                                )
                            )
                            .asDays();

                        var expiryDate;
                        if (daysDiff <= 0) {
                            expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                                "DD/MM/YYYY"
                            );
                        } else {
                            expiryDate = moment(
                                birthDay + "/" + birthMonth + "/" + startYear,
                                "DD/MM/YYYY"
                            )
                                .add(11, "years")
                                .format("DD/MM/YYYY");
                        }

                        while (
                            (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
                            ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
                            expiryDate = moment(
                                expiryDate,
                                "DD/MM/YYYY"
                            )
                                .add(10, "years")
                                .format("DD/MM/YYYY");
                        }

                        if (moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0 && $scope.pfForm && $scope.pfForm.dataScadenza) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        if (moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2 && $scope.pfForm && $scope.pfForm.dataScadenza) {
                            $scope.pfForm.dataScadenza.$valid = false;
                            $scope.pfForm && $scope.pfForm.dataScadenza && $scope.pfForm.dataScadenza.$setValidity("dataScadenza", false);
                        } else {
                            $scope.pfForm && $scope.pfForm.dataScadenza && $scope.pfForm.dataScadenza.$setValidity("dataScadenza", true);
                        }
                        return expiryDate;
                    } else {
                        if (
                            moment
                                .duration(
                                    moment(
                                        self.userDaCensire.documento.dataScadenza,
                                        "DD/MM/YYYY"
                                    ).diff(moment(endDate, "DD/MM/YYYY"))
                                )
                                .asDays() > 0
                        ) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        return endDate;
                    }
                } else {
                    return moment(self.today, "DD/MM/YYYY")
                        .add(10, "years")
                        .format("DD/MM/YYYY");
                }

            };

            self.validateForm = function () {
                if (!self.showAllInfo) {
                    self.allDocumentUploaded = checkFilesUpload();
                    self.allDatiCompleti = !!self.userDaCensire.documento.provincia &&
                        (!!self.userDaCensire.documento.luogoEsteso.nome || (self.userDaCensire.documento.provincia == 'EE' && self.userDaCensire.documento.luogo)) &&
                        !!self.userDaCensire.documento.numero &&
                        !!self.userDaCensire.documento.dataRilascio &&
                        !!self.userDaCensire.documento.dataScadenza &&
                        !!self.allDocumentUploaded
                    var regex = new RegExp(validationService.getDocTypeRegex(self.userDaCensire.documento.tipo));
                    self.testRegexDoc = regex.test(self.userDaCensire.documento.numero);
                    return self.allDatiCompleti && self.testRegexDoc;
                } else if (self.editModeMinimal) {
                    return !!self.userDaCensire.firmatario &&
                        !!self.userDaCensire.firmatario.ruolo
                } else {
                    self.allDocumentUploaded = checkFilesUpload();
                    var check = self.userDaCensire.firmatario.selected;
                    if (self.userDaCensire.residenza.provincia != "EE") {
                        if (check) {
                            if (self.userDaCensire.garante.selected) {

                                return $scope.pfForm.$valid &&
                                    self.userDaCensire.firmatario.ruolo &&
                                    self.userDaCensire.residenza.cap &&
                                    self.userDaCensire.residenza.luogoEsteso.nome &&
                                    self.userDaCensire.documentiCaricati &&
                                    self.allDocumentUploaded &&
                                    !!self.userDaCensire.documento.tipo &&
                                    self.testDati.value &&
                                    (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                            } else {
                                return $scope.pfForm.$valid &&
                                    self.userDaCensire.firmatario.ruolo &&
                                    self.userDaCensire.residenza.cap &&
                                    self.userDaCensire.residenza.luogoEsteso.nome &&
                                    self.userDaCensire.documentiCaricati &&
                                    self.allDocumentUploaded &&
                                    !!self.userDaCensire.documento.tipo &&
                                    self.testDati.value &&
                                    (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)
                            }

                        } else if (!check && !self.userDaCensire.garante.selected) {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.userDaCensire.documentiCaricati &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                        } else {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.userDaCensire.documentiCaricati &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value

                        }
                    } else {
                        if (check) {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.firmatario.ruolo &&
                                self.userDaCensire.documentiCaricati &&
                                self.allDocumentUploaded &&
                                self.userDaCensire.residenza.stato &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                        } else if (!check && !self.userDaCensire.garante.selected) {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.documentiCaricati &&
                                self.allDocumentUploaded &&
                                self.userDaCensire.residenza.stato &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                        } else {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.userDaCensire.documentiCaricati &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value

                        }
                    }

                }


            };

            self.getTodaysDate = function () {
                return moment().format("DD/MM/YYYY");
            };


            self.verifyDate = function () {
                self.testDati.value = true;
                var codCat;
                if (self.userDaCensire && self.userDaCensire.datiNascita &&
                    self.userDaCensire.datiNascita.luogoEsteso &&
                    self.userDaCensire.datiNascita.luogoEsteso.nome) {
                    var comuniCompleti = self.mapComuni.concat(self.comuniNsilSoppressi);
                    var tempCodCat = comuniCompleti
                        .filter(function (element) {
                            return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                        })[0].codiceCatastale;
                    codCat = self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale ? self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
                } else if (self.userDaCensire && self.userDaCensire.datiNascita && self.userDaCensire.datiNascita.stato.name) {
                    codCat = self.userDaCensire.datiNascita.stato.value;
                }
                if (!codCat) {
                    self.testDati.value = false;
                    return;
                }

                self.testDati = validationService.checkCfWithFieds(
                    self.userDaCensire.cf,
                    self.userDaCensire.nome,
                    self.userDaCensire.cognome,
                    self.userDaCensire.datiNascita.data,
                    self.userDaCensire.sesso,
                    codCat
                );

                if (!self.testDati.value) {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", false);
                    }
                } else {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", true);
                    }
                }

            };

            self.disabledUploadDocument = function () {
                if (self.uploadDocumenti === "imgCf") {
                    self.uploadCfCompleted = false;
                } else {
                    self.uploadDocCompleted = false;
                    self.frontBase64 = "";
                    self.backBase64 = "";
                }
                self.disabledUploadCf = self.documentUpload.some(function (elem) {
                    return elem.type === "imgCf";
                });

                var temp = 0;

                self.documentUpload.forEach(function (elem) {
                    if (elem.type === "imgDocument") {
                        temp++;
                    }

                    if (temp >= 2) {
                        self.disabledUploadDocIdent = true;
                    } else {
                        self.disabledUploadDocIdent = false;
                    }
                });
            };

            var dealerUser = function () {
                if ($portalService.isAru()) {

                    $userService.getDealerUser()
                        .then(function (dealer) {
                            if (dealer) {
                                self.dealerUser = dealer;
                            }
                        });
                }
            }


            self.$onDestroy = function () {
                clearInterval(self.intervalOfRepeatListenMobileCapture);

                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
            }


            /* Parte da eliminare */

            self.getFromDomain = function (table, value, list, delay, cb) {
                $timeout(function () {
                    HttpService.send('/uni/typedomain/getDomainSet', {
                        table: table,
                        column: value
                    }, false)
                        .then(function (response) {
                            if (list) {
                                self.dropdown[list] = response.domainList;
                            }

                            if (cb) {
                                cb(response);
                            }
                        });
                }, delay);
            }


            self.getFromDomain('RI_DROPDOWN_DOMAINS', 'DOCUMENT_TYPE', 'tipiDocumento', 20, function () {

                for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                    if (self.dropdown.tipiDocumento[i].value == "CAE") {
                        self.dropdown.tipiDocumento[i].order = 40;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CAI") {
                        self.dropdown.tipiDocumento[i].order = 10;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CIE") {
                        self.dropdown.tipiDocumento[i].order = 20;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "NCE") {
                        self.dropdown.tipiDocumento[i].order = 30;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAM") {
                        self.dropdown.tipiDocumento[i].order = 50;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAS") {
                        self.dropdown.tipiDocumento[i].order = 80;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAT") {
                        self.dropdown.tipiDocumento[i].order = 60;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "UCO") {
                        self.dropdown.tipiDocumento[i].order = 70;
                    }

                    self.dropdown.tipiDocumento = self.dropdown.tipiDocumento
                        .filter(function (element) {
                            return element.value != "CAE"
                        })

                }


            });

            self.setDocNumRegex = function (tipoDocumento, fromUploadFinish) {
                console.log(tipoDocumento);
                self.regExpDocumento = tipoDocumento;
                switch (tipoDocumento) {
                    case 'UCO':
                        self.listaNomeRilascio = Documento.getEntiRilascio("PAT");
                        self.listaNomeRilascio = self.listaNomeRilascio
                            .filter(function (element) {
                                return element.name == "MINISTERO"
                            })
                        break;
                    case 'PAT':
                        self.listaNomeRilascio = Documento.getEntiRilascio("PAT");
                        self.listaNomeRilascio = self.listaNomeRilascio
                            .filter(function (element) {
                                return element.name == "PREFETTURA"
                            })
                        break;
                    case 'PAM':
                        self.listaNomeRilascio = Documento.getEntiRilascio("PAT");
                        self.listaNomeRilascio = self.listaNomeRilascio
                            .filter(function (element) {
                                return element.name == "DIPARTIM. TRASPORTI TERRESTI"
                            })
                        break;

                    default:
                        self.listaNomeRilascio = Documento.getEntiRilascio(tipoDocumento);
                        break;
                }

                if (tipoDocumento == 'PAS' || tipoDocumento == 'CAE') {
                    var testIfPresent = self.listaProvinceRilascio.findIndex(function (element) {
                        return element == 'EE'
                    })
                    if (testIfPresent < 0) {
                        self.listaProvinceRilascio.push('EE');
                    }
                } else {
                    self.listaProvinceRilascio = self.listaProvinceRilascio.filter(function (element) {
                        return element != 'EE'

                    });

                }
                if (tipoDocumento == 'CAE') {
                    self.userDaCensire.documento.provincia = 'EE';
                    self.disabledProvRilascioEstera = true;
                } else {
                    self.userDaCensire.documento.provincia = null;
                    self.disabledProvRilascioEstera = false;
                }
                self.listaEntiRilascio();
                self.userDaCensire.documento.tipo = tipoDocumento;
                self.enteRilascioSelezionato(self.listaNomeRilascio[0].name);
                self.enteRilascioModel = self.listaNomeRilascio[0];

                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != 'imgDocument'
                });
                self.disabeldUploadBack = false;
                self.disabeldUploadFront = false;
            }


            self.uploadFinish = function (fromChangeDoc) {
                self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                self.unlockDocumentFields = true;
                if (fromChangeDoc) {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo);
                } else {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo, true);
                }
            }




            self.upgradeListaComuni = function (value) {
                if (self.userDaCensire.documento.provincia) {
                    self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                }
                self.userDaCensire.documento.luogoEsteso = {
                    nome: value
                }
            }

            var checkFilesUpload = function () {
                var test = false
                if (self.postVendita.applicationName == 'RISCATTO' || self.postVendita.applicationName == 'RISCATTO_TERMINE') {
                    if (self.userDaCensire.numDocumenti == 1) {
                        test = self.userDaCensire.documento.uploadedDoc && self.userDaCensire.documento.uploadedDoc.length > 0;

                    } else if (self.userDaCensire.numDocumenti == 2) {

                        test = !!self.userDaCensire.documento.idImgDocumentoCfFront &&

                            !!self.userDaCensire.documento.idImgDocumentoFront;

                    } else if (self.userDaCensire.numDocumenti == 4) {

                        test = !!self.userDaCensire.documento.idImgDocumentoCfFront &&
                            !!self.userDaCensire.documento.idImgDocumentoFront &&
                            !!self.userDaCensire.documento.idImgDocumentoFrontOther &&
                            !!self.userDaCensire.documento.idImgSubjectPhoto;

                    }

                } else {
                    if (self.userDaCensire.numDocumenti == 1) {
                        test = !!self.userDaCensire.documento.idImgDocumentoBack &&
                            !!self.userDaCensire.documento.idImgDocumentoFront;

                    } else if (self.userDaCensire.numDocumenti == 2) {

                        test = !!self.userDaCensire.documento.idImgDocumentoCfBack &&
                            !!self.userDaCensire.documento.idImgDocumentoCfFront &&
                            !!self.userDaCensire.documento.idImgDocumentoBack &&
                            !!self.userDaCensire.documento.idImgDocumentoFront;

                    } else if (self.userDaCensire.numDocumenti == 4) {

                        test = !!self.userDaCensire.documento.idImgDocumentoCfBack &&
                            !!self.userDaCensire.documento.idImgDocumentoCfFront &&
                            !!self.userDaCensire.documento.idImgDocumentoBack &&
                            !!self.userDaCensire.documento.idImgDocumentoFront &&
                            !!self.userDaCensire.documento.idImgDocumentoBackOther &&
                            !!self.userDaCensire.documento.idImgDocumentoFrontOther &&
                            !!self.userDaCensire.documento.idImgSubjectPhoto;

                    }

                }


                return test;

            }

            self.setStatoDoc = function (statoSelected) {
                self.userDaCensire.documento.stato = statoSelected;
                self.userDaCensire.documento.statoEsteso = self.listaNomiStatiNascita.find(function (element) {
                    return element.name == statoSelected;
                })
            }

            self.setDate = function (tipo, value) {
                if (tipo === 'dataRilascio') {
                    self.userDaCensire.documento.dataRilascio = value;
                } else {
                    self.userDaCensire.documento.dataScadenza = value;
                }
            }

        }

    });
